import { SvgElement } from '@axinom/mosaic-ui';
import React from 'react';
import type { NavigationItem } from './types';

const AdminSettingsIcon: React.FC = () => {
  return (
    <SvgElement viewBox="0 0 40 40 ">
      <path
        vectorEffect="non-scaling-stroke"
        fill="none"
        stroke="var(--mosaic-primary, #28AAE1)"
        strokeWidth="1.5"
        d="M31.4,16.9l5.6.9v4.5l-5.4.9c-.1.8-.6,1.9-1.1,2.8l3.2,4.5-3.2,3.2-4.3-3.2c-.8.7-1.6,1.1-2.8,1.3l-.9,5.4h-4.5l-.9-5.4c-1.2-.3-1.9-.6-2.8-1.3l-4.5,3.2-3.2-3.2,3.2-4.5c-.4-.9-.9-1.7-1.1-2.8l-5.6-.9v-4.5l5.6-.9c.2-.9.6-1.7,1.1-2.6l-3.2-4.8,3.2-3.2,4.5,3.2c.9-.4,1.7-.9,2.6-1.1l.9-5.6h4.5l.9,5.6c.9.2,1.7.6,2.6,1.1l4.5-3.2,3.2,3.2-3.2,4.5h0s.8,1.2,1.1,2.8h0ZM19.7,16.2c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9,3.9-1.7,3.9-3.9-1.7-3.9-3.9-3.9Z"
      />
    </SvgElement>
  );
};

export const AdminSettings: NavigationItem = {
  name: 'admin-settings',
  label: 'Admin Settings',
  categoryName: 'Settings',
  icon: <AdminSettingsIcon />,
  pilet: 'mosaic-portal',
};
